module.exports = __webpack_public_path__ + "static/media/info-background.801d0ca7.png";